import { Plugins } from '@capacitor/core'
const { App } = Plugins

import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import routes from './async-routes'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'launch',
			component: routes.launch,
			meta: { guest: true }
		},
		{
			path: '/categories',
			name: 'categories',
			component: routes.categories,
			meta: { guest: true }
		},
		{
			path: '/results',
			name: 'results',
			component: routes.results,
			meta: { guest: true }
		},
		{
			path: '/details/:uuid',
			name: 'details',
			component: routes.details,
			meta: { guest: true }
		},
		{
			path: '/Login/:redirect?',
			name: 'login',
			component: routes.login,
			meta: { guest: true },
			props: true
		},
		{
			path: '/Register',
			name: 'register',
			component: routes.register,
			meta: { guest: true },
			props: true
		},
		{
			path: '/Register/email',
			name: 'register-email',
			component: () => import('@/components/Auth/EmailRegisterView'),
			meta: { guest: true }
		},
		{
			path: '/Register/:uuid',
			name: 'register-deep',
			component: () => import('@/components/Auth/DeepRegisterView'),
			meta: { guest: true, ignoreAuth: true },
			props: true
		},
		{
			path: '/Register/group/:uuid',
			name: 'register-group',
			component: () => import('@/components/Auth/GroupRegisterView'),
			meta: { guest: true, ignoreAuth: true },
			props: true
		},
		{
			path: '/Donate/Success/:uuid',
			name: 'donate-success',
			component: () => import('@/components/Auth/DonationSuccess'),
			meta: { guest: true },
			props: true
		},
		{
			path: '/Donate/:uuid',
			name: 'donate-deep',
			component: () => import('@/components/Auth/DeepDonateView'),
			meta: { guest: true, ignoreAuth: true },
			props: true
		},
		{
			path: '/ForgotPassword',
			name: 'forgot-password',
			component: () => import('@/components/Auth/ForgotPasswordView'),
			meta: { guest: true }
		},
		{
			path: '/ResetPassword/:uuid',
			name: 'reset-password',
			component: () => import('@/components/Auth/ResetPasswordView'),
			meta: { guest: true },
			props: true
		},
		{
			path: '/Authenticate/:uuid/:path',
			name: 'authenticate',
			component: () => import('@/components/Auth/HandleTokenAuth'),
			meta: { tokenAuth: true, guest: true },
			props: true
		},
		{
			path: '/SetupPassword/:uuid',
			name: 'setup-password',
			component: () => import('@/components/Auth/SetupPasswordView'),
			meta: { guest: true },
			props: true
		},
		{
			path: '/RedirectToApp',
			name: 'redirect',
			component: () => import('@/components/Auth/RedirectToApp'),
			meta: { guest: true }
		},
		{
			path: '/Logout',
			name: 'logout',
			beforeEnter: (to, from, next) => {
				localStorage.clear()
				store.dispatch('logout').then(() => {
					next({ name: 'launch' })
				})
			}
		},
		{
			path: '/Institutions',
			name: 'institutions',
			component: () =>
				import('@/components/Institution/InstitutionListView'),
			meta: { onboarding: true },
			props: true
		},
		{
			path: '/MinDonation',
			name: 'mindonation',
			component: () => import('@/components/Account/MinDonationView.vue'),
			meta: { onboarding: true },
			props: true
		},
		{
			path: '/WholeDollar',
			name: 'wholedollar',
			component: () => import('@/components/Account/WholeDollarView.vue'),
			meta: { onboarding: true },
			props: true
		},
		{
			path: '/Accounts',
			name: 'accounts',
			component: routes.accounts,
			meta: { onboarding: true },
			props: true
		},
		{
			path: '/PreCard',
			name: 'pre-card',
			component: () => import('@/components/Card/PreCardView'),
			meta: { onboarding: true }
		},
		{
			path: '/Card',
			name: 'card',
			component: () => import('@/components/Card/CardView'),
			meta: { onboarding: true },
			props: true
		},
		{
			path: '/PrePlaid',
			name: 'pre-plaid',
			component: () => import('@/components/Plaid/PrePlaidView'),
			meta: { onboarding: true },
			props: true
		},
		{
			path: '/Home',
			name: 'home',
			component: routes.home
		},
		{
			path: '/Donations',
			name: 'roundups',
			component: routes.donations
		},
		{
			path: '/Designations',
			name: 'designations',
			component: routes.designations
		},
		{
			path: '/DonateNow',
			name: 'one-time-donate',
			component: () => import('@/components/Donate/OneTimeDonate')
		},
		{
			path: '/DonateNow/Success',
			name: 'one-time-donate-success',
			component: () => import('@/components/Donate/Success')
		},
		{
			path: '/Settings',
			name: 'settings',
			component: routes.settings
		},
		{
			path: '/Settings/MinMax',
			name: 'settings.cap',
			component: () => import('@/components/Settings/MaxMinView')
		},
		{
			path: '/Settings/Legal',
			name: 'settings.legal',
			component: () => import('@/components/Settings/LegalView')
		},
		{
			path: '/Settings/ChangePassword',
			name: 'settings.password',
			component: () => import('@/components/Settings/ChangePassView')
		},
		{
			path: '/Settings/UpdateUser',
			name: 'settings.user',
			component: () => import('@/components/Settings/UpdateUserView')
		},
		{
			path: '/Settings/AppDetails',
			name: 'settings.details',
			component: () => import('@/components/Settings/AppDetails')
		},
		{
			path: '/Settings/ChangeInstitution',
			name: 'settings.institution',
			component: () =>
				import('@/components/Institution/InstitutionListView')
		}
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
})

router.beforeEach((to, from, next) => {
	//remove frame styling for group register page
	if (from.name === 'register-group') {
		var parent = document.getElementById('parent')
		parent.style.maxWidth = '450px'
		parent.style.position = 'relative'
	}

	// Make sure you let tokened users log in
	if (to.meta.tokenAuth) {
		next()
		return
	}

	// Make sure you always let people login
	if (to.meta.guest && !store.state.me.isLoggedIn) {
		if (process.env.VUE_APP_INSTITUTION_UUID && to.name === 'launch') {
			next({
				name: 'register-deep',
				params: { uuid: process.env.VUE_APP_INSTITUTION_UUID }
			})
			return
		}
		next()
		return
	}

	if (to.name === 'logout') {
		next()
		return
	}

	try {
		if (window.analytics) {
			window.analytics.page(to.fullPath, {
				referrer: window.location.origin + '/#' + from.path,
				url: window.location.origin + '/#' + to.fullPath
			})
		}
	} catch {}

	// Ensure we have a user object before we start routing
	store.dispatch('checkUserLoad').then(
		() => {
			// Save previous page on every route change
			if (from.name !== 'login' && from.name !== 'launch') {
				localStorage.setItem('prevPage', from.path)
			}
			if (
				!store.getters.hasCompletedSignup &&
				['donate-success', 'setup-password'].includes(to.name)
			) {
				next()
				return
			}

			//if landing on public page, stay there
			if (to.meta.ignoreAuth) {
				next()
				return
			}

			if (!store.getters.hasCompletedSignup && !to.meta.onboarding) {
				const nextStep = store.getters.nextSignupStep
				if (
					nextStep == 'pre-plaid' &&
					localStorage.getItem('roundup_skip')
				) {
					true
				} else if (nextStep !== to.name) {
					next({
						name: store.getters.nextSignupStep,
						params: { onboarding: true }
					})
					return
				}
			}

			// If you are trying to go to the login screen, send you to home
			if (
				to.meta.guest &&
				store.state.me.isLoggedIn &&
				to.name !== 'redirect'
			) {
				next({ name: 'home' })
				return
			}

			try {
				if (window.analytics) {
					window.analytics.identify(
						store.state.me.current.id,
						store.state.me.current
					)
				}
			} catch {}

			// If everything is still golden, lets keep going
			next()
		},
		() => {
			next({
				name: 'login',
				params: { redirect: to.name }
			})
		}
	)
})

App.addListener('appUrlOpen', function (data) {
	// Example url: https://roundup.app/app/tabs/tabs2
	// slug = /tabs/tabs2
	const slug = data.url.split('roundupapp:/').pop()

	// We only push to the route if there is a slug present
	if (slug) {
		router.push({
			path: slug
		})
	}
})

export default router
